import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/contexts/ThemeContext";
import Home from "@/pages/Home";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-center"
          richColors
          closeButton
          toastOptions={{
            className: "font-body",
          }}
        />
      </div>
    </ThemeProvider>
  );
}

export default App;
